import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MeasureService } from 'src/app/modules/measure/measure.service';

@Injectable({
  providedIn: 'root'
})
export class MeasureCheckViewGuard implements CanActivate {
  constructor(
    private measureService: MeasureService,
    private _router: Router
  ) { }

  canActivate() {
    let link = window.location.pathname.split("/")[2];

    if (link) {
      return this.measureService.getNormalMeasureByLink(link).pipe(
        map(res => {
          if (res.result[0].IS_VIEW === 0) {
            return true;
          } else {
            alert('แบบทดสอบนี้ไม่ได้อยู่ในช่วงให้ทำแบบทดสอบ กรุณาลองใหม่อีกครั้ง');
            this._router.navigate(['/measure']);
            return false;
          }
        }),
        catchError(() => {
          this._router.navigate(['/measure']);
          return of(false);
        })
      );
    } else {
      return true;
    }
  }
}
